export const formatCurrency = (n: number): string =>
  `£${n.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

// Parses a local calendar date from a YYYY-MM-DD string without timezone shifts.
export const parseYmdToLocalDate = (ymd: string): Date | null => {
  const m = /^([0-9]{4})-([0-9]{2})-([0-9]{2})$/.exec(ymd);
  if (!m) return null;
  const y = Number(m[1]);
  const mo = Number(m[2]);
  const d = Number(m[3]);
  const dt = new Date(y, mo - 1, d);
  // Validate that the components round-trip (catches 2025-02-30 etc.)
  if (dt.getFullYear() !== y || dt.getMonth() !== mo - 1 || dt.getDate() !== d) return null;
  return dt;
};

export const formatUKDate = (d: Date | string): string => {
  let date: Date | null = null;
  if (typeof d === 'string') {
    date = parseYmdToLocalDate(d);
    if (!date) {
      const tmp = new Date(d);
      date = isNaN(tmp.getTime()) ? null : tmp;
    }
  } else {
    date = d;
  }

  if (!date || isNaN(date.getTime())) return 'Invalid date';
  const dd = String(date.getDate()).padStart(2, '0');
  const mm = String(date.getMonth() + 1).padStart(2, '0');
  const yyyy = date.getFullYear();
  return `${dd}-${mm}-${yyyy}`;
};
